import React from 'react';
import { Link } from 'react-router-dom';
import '../../styles/WorkWithUs.css';

const ImageOverlayCard = ({ image, logo, title, description, link }) => {
  const hasImage = !!image;
  const hasLogo = !!logo;

  const backgroundStyle = hasImage
    ? { backgroundImage: `url(${image})` }
    : { backgroundColor: '#E2D4C7' };

  return (
    <div className={`overlayCard ${hasLogo ? 'has-logo' : ''}`}>
      <div className="backgroundImage" style={backgroundStyle}>
        <div className={`overlayContent ${hasLogo ? 'fullOverlay' : ''}`}>
          {hasLogo && (
            <div className="cardLogoWrapper">
              <img src={logo} alt="Logo" className="cardLogo" />
            </div>
          )}
          <h3>{title}</h3>
          <p>{description}</p>
          {link && (
            <Link to={link} className='workLink'>
              Learn More
            </Link>
          )}
        </div>
      </div>
    </div>
  );
};

export default ImageOverlayCard;
